import { render, staticRenderFns } from "./CatalogSearchResult.vue?vue&type=template&id=c5e304ae&scoped=true"
import script from "./CatalogSearchResult.vue?vue&type=script&lang=ts"
export * from "./CatalogSearchResult.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSearchResult.vue?vue&type=style&index=0&id=c5e304ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e304ae",
  null
  
)

export default component.exports